import { render, staticRenderFns } from "./ProfileActivitiesShortlist.vue?vue&type=template&id=02b36b98&"
import script from "./ProfileActivitiesShortlist.vue?vue&type=script&lang=js&"
export * from "./ProfileActivitiesShortlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports